import { utcToZonedTime } from 'date-fns-tz';

export function getZonedTime(timeMs: Maybe<number>, timezone: Maybe<string>): Maybe<Date> {
  if (timeMs && timezone) {
    return utcToZonedTime(new Date(timeMs), timezone);
  }
  return null;
}
